import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../styles/helpers/flexbox';

export const ResultCellWrapper = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    width: 140px;
    height: 70px;

    color: ${palette.primary.dark};
  `;
});

export const Title = styled.div`
  ${flexbox()};

  width: 100%;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
`;

export const Content = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  width: 100%;
  height: 35px;
  font-size: 12px;
  border: 1px solid ${colours.grey[300]};
  border-radius: 4px;
  padding-top: 3px;
`;
});

export const ResultContainerWrapper = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    width: 140px;

    color: ${palette.primary.dark};
    border-radius: 4px;
    padding: 10px;
  `;
});

export const ContainerContent = styled.div((props) => {
  const { palette, colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    width: 170px;
    min-height: 160px;

    color: ${palette.primary.dark};
    border: 1px solid ${colours.grey[300]};
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
  `;
});

export const IconWrapper = styled.div`
  margin-right: 10px;
  margin-bottom: 2px;
  width: 20px;
  height: 20px;
`;



// WEBPACK FOOTER //
// ./components/result-cell/result-cell.styled.js